import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import * as actions from '../actions';
import * as actionCreators from '../action-creators';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import * as auth from '@webapp/sdk/auth';
import AppState from '@webapp/store/state';

export const changeLoginEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, actionCreators.ChangeLogin>(actions.CHANGE_LOGIN),
    withLatestFrom(state$),
    mergeMap(async ([{ data }, state]) => {
      try {
        const user = await auth.getUser();

        const { phone_number: validPhone } = user.attributes;
        const validEmail = state.user.profile?.email;

        let params: Record<string, string | undefined> = {};

        if (data?.email && validEmail !== data.email) {
          params = {
            email: data.email,
            'custom:valid_email': validEmail,
          };
        } else if (data?.telephone && validPhone !== data.telephone) {
          params = {
            phone_number: data.telephone,
            'custom:valid_phone': validPhone,
          };
        }

        const shouldVerify = !isEmpty(params);

        if (shouldVerify) {
          await auth.updateUser(user, pickBy(params));
        }

        return new actionCreators.ChangeLoginSuccess(
          user.username,
          shouldVerify
        );
      } catch (err) {
        return new actionCreators.ChangeLoginError(err.code);
      }
    })
  );
